import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';

import { Representante } from '../representante';

@Injectable({
    providedIn: 'root'
})
export class TypeaheadRepresentanteHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiTypeahead()}/representante`
    }

    /** Pesquisa todos os representantes cadastrados para o typeahead */
    search(nomeCodigoCnpjCpf: string, situacao: number, limit: number): Observable<Representante[]> {
        // Params
        let params = new HttpParams()
                            .append('nomeCodigoCnpjCpf', nomeCodigoCnpjCpf); // Nome, código e CNPJ/CPF
        // Situação
        if (situacao) {
            params = params.append('situacao', situacao.toString());
        }
        // Limit
        params = params.append('limit', limit ? limit.toString() : null);

        return this.customHttp.get(this.pathApi, {params});
    }
}
